import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const processEnv =
  typeof process !== 'undefined' && process?.env
    ? (process.env as Record<string, string | undefined>)
    : undefined;

const isBrowser = typeof window !== 'undefined';

const getRequiredFirebaseEnv = (key: string, value: string | undefined): string => {
  if (!value || !value.trim()) {
    throw new Error(`Missing required Firebase env var: ${key}`);
  }
  return value;
};

const firebaseApiKey = getRequiredFirebaseEnv(
  'VITE_FIREBASE_API_KEY',
  isBrowser ? import.meta.env.VITE_FIREBASE_API_KEY : processEnv?.VITE_FIREBASE_API_KEY
);

const firebaseAuthDomain = getRequiredFirebaseEnv(
  'VITE_FIREBASE_AUTH_DOMAIN',
  isBrowser ? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN : processEnv?.VITE_FIREBASE_AUTH_DOMAIN
);

const firebaseProjectId = getRequiredFirebaseEnv(
  'VITE_FIREBASE_PROJECT_ID',
  isBrowser ? import.meta.env.VITE_FIREBASE_PROJECT_ID : processEnv?.VITE_FIREBASE_PROJECT_ID
);

const firebaseStorageBucket = getRequiredFirebaseEnv(
  'VITE_FIREBASE_STORAGE_BUCKET',
  isBrowser ? import.meta.env.VITE_FIREBASE_STORAGE_BUCKET : processEnv?.VITE_FIREBASE_STORAGE_BUCKET
);

const firebaseMessagingSenderId = getRequiredFirebaseEnv(
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  isBrowser ? import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID : processEnv?.VITE_FIREBASE_MESSAGING_SENDER_ID
);

const firebaseAppId = getRequiredFirebaseEnv(
  'VITE_FIREBASE_APP_ID',
  isBrowser ? import.meta.env.VITE_FIREBASE_APP_ID : processEnv?.VITE_FIREBASE_APP_ID
);

export const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
  measurementId: isBrowser ? import.meta.env.VITE_FIREBASE_MEASUREMENT_ID : processEnv?.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Configure auth persistence
if (isBrowser) {
  setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.warn("[firebase] Failed to configure auth persistence:", error);
  });
}

export default app;
